<template>
    <div id="departmentTree" ref="treebox">
            <div class="dragbox" v-show="!arrowShow" style="min-height:436px;border-left:none">
                    <div class="topsan"></div>
                    <div class="bgc-drag" @click="arrowspan">
                        <i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="bottomsan"></div>
            </div>
            <div class="tree-left" ref="treeleft" id="treeleft" v-show="arrowShow">
                <div class="search-header-wraper">
                        <el-input placeholder="按部门名称搜索" 
                            v-model.trim="departmentSearch"
                            maxlength="30" 
                            size="medium"
                            style="width:195px"
                            @keyup.enter.native="depSearchClick('showall')">
                                <i slot="suffix" class="el-input__icon el-icon-search" style="cursor:pointer" @click="depSearchClick('showall')"></i>
                        </el-input>
                            
                            <el-tooltip class="item"  effect="dark" content="收起" placement="top" v-if="isExpandall">
                                <div class="fold-div" @click="foldbtnClick">
                                    <i class="iconfont icon-shouqi" ></i>
                                </div>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="展开" placement="top" v-else>
                                <div class="fold-div" @click="expandbtnClick">
                                    <i class="iconfont icon-zhankai2" ></i>
                                </div>
                            </el-tooltip>
                </div>
                <div class="mytree">
                    <el-tree
                        v-loading="treeloading"
                        element-loading-text="拼命加载中..." 
                        :data="treedata" 
                        :props="defaultProps" 
                        node-key="id"
                        :highlight-current="true"
                        class="eltree"
                        ref="departmenttree"
                        :default-expanded-keys="defaultexpandedkeys"
                        @node-expand="nodeExpand"
	                    @node-collapse="nodeCollapse"
                        @node-click="nodeclick">
                        <span class="custom-tree-node" slot-scope="{ node , data }" @mouseleave= nodemouseleave(data,$event)>
                            <span  class="custom-label" v-if="data.isOperate">
                                <el-input
                                v-if="data.type=='edit'"
                                v-model.trim="editLabel" 
                                placeholder="" 
                                :ref="'slotTreeInput' + data.id"
                                size="mini"
                                maxlength="30"
                                style="width:150px;font-size:14px;"
                                @blur.stop="editblur(node,data)"
                                @keyup.enter.native="editblur(node,data)"
                                key="edit">
                                
                                </el-input>
                                <el-input
                                v-else-if="data.type=='add'"
                                v-model.trim="addLabel" 
                                placeholder="" 
                                :ref="'slotaddInput' + data.id"
                                size="mini"
                                maxlength="30"
                                class="inputadd"
                                style="width:150px;font-size:14px;"
                                @blur.stop="addblur(node,data)"
                                @keyup.enter.native="addblur(node,data)"
                                key="add">
                                </el-input>
                            </span>
                            <span v-else>
                                <span @mouseover=nodemouseover(data,$event) class="custom-label" >{{ node.label }}</span>
                                <span  v-show="data.dropdownShow && isCanLabelHover">
                                    <span style="padding-left:8px" class="opthover">
                                        <i class="el-icon-plus " @click.stop="()=>addBtnClick(node,data)"></i>
                                    </span>
                                    <span style="padding-left:6px" class="opthover" @click.stop="()=>editBtnClick(node,data)"> 
                                        <i class="el-icon-edit"></i>
                                    </span>
                                    <span style="padding-left:6px" class="opthover" @click.stop="()=>deleteBtnClick(node,data)">
                                        <i class="el-icon-delete "></i>
                                    </span>  
                                </span>
                            </span>   
                        </span>
                    </el-tree>
                </div>
            </div>
            <div class="dragbox" id="treeresize" v-show="arrowShow" style="min-height:436px">
                    <div class="topsan"></div>
                    <div class="bgc-drag" @click="arrowfold">
                        <i class="el-icon-arrow-left"></i>
                    </div>
                    <div class="bottomsan"></div>
            </div> 
                       
    </div>
</template>

<script>
import {GetEnterpriseDepartmentApi,
CreateEnterpriseDepartmentApi,
DeleteEnterpriseDepartmentApi,
EditEnterpriseDepartmentApi,
GetEnterpriseDepartmentStatusApi} from '@/js/enterPriseApi.js'
    export default {
        data(){
            return {
                departmentSearch:'',
                startclientX: 0, // 元素拖拽前距离浏览器的X轴位置
                elLeft: 0, // 元素的左偏移量
                arrowShow:true,
                treedata:  [
                ],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                editLabel:'',//编辑input标签展示
                addLabel:'',//添加input标签展示
                isCanLabelHover:true,//鼠标移动是否展示操作
                defaultexpandedkeys:[],//默认展开节点的数组
                isExpandall:false,//全部展开和全部收起
                treeloading:false,
                currentdepid:'',
            }
        },
        created(){
            if(window.localStorage.getItem('enterPriseId')){
                this.GetEnterpriseDepartment({
                    enterpriseId:localStorage.getItem('enterPriseId'),
                },true)//获取部门企业
            }
        },
        mounted(){
            this.dragControllerDiv()//添加拖拽事件
        },
        methods:{
            nodeExpand(data) {//节点展开事件
                let flag = false
                this.defaultexpandedkeys.some(item => {
                    if (item === data.id) { // 判断当前节点是否存在， 存在不做处理
                    flag = true
                    return true
                    }
                })
                if (!flag) { // 不存在则存到数组里
                    this.defaultexpandedkeys.push(data.id)
                }
            },
            nodeCollapse(data) {//节点折叠事件
                
                if(data.parentId==null){
                    return 
                }
                this.defaultexpandedkeys.some((item, i) => {
                    if (item === data.id) {
                    this.defaultexpandedkeys.splice(i, 1)
                    }
                })
                this.removeChildrenIds(data) // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点      
            },
            nodeclick(data,node){//节点点击事件
                
                if(this.currentdepid==data.id){
                    return 
                }else{
                    this.currentdepid=data.id;
                    this.$emit('refreshUser',data.id)
                }
            },
            removeChildrenIds(data){
                const ts = this
                if (data.children) {
                    data.children.forEach(function(item) {
                    const index = ts.defaultexpandedkeys.indexOf(item.id)
                    if (index > 0) {
                        ts.defaultexpandedkeys.splice(index, 1)
                    }
                    ts.removeChildrenIds(item)
                    })
                }
            },
            expandSecondLevel(){//默认展开二级节点
                if(this.defaultexpandedkeys.includes(this.treedata[0].id)){
                    return 
                }else{
                    this.defaultexpandedkeys.push(this.treedata[0].id)
                }
            },
            expandbtnClick(){//展开所有节点   
                for (var i = 0; i < this.$refs.departmenttree.store._getAllNodes().length; i++) {
                    this.$refs.departmenttree.store._getAllNodes()[i].expanded = true;
                    
                    //记录节点展开状态
                    let ids=this.$refs.departmenttree.store._getAllNodes()[i].data.id;
                    this.defaultexpandedkeys.push(ids)
                }
                this.isExpandall=true
            },
            foldbtnClick(){//收起全部按钮,树节点折叠
                for (var i = 0; i < this.$refs.departmenttree.store._getAllNodes().length; i++) {
                    this.$refs.departmenttree.store._getAllNodes()[i].expanded = false;
                }
                this.$refs.departmenttree.store._getAllNodes()[0].expanded = true;
                this.defaultexpandedkeys.splice(0,this.defaultexpandedkeys.length)
                this.isExpandall=false
            },
            depSearchClick(showall){//搜索部门按钮点击
                this.defaultexpandedkeys.splice(0,this.defaultexpandedkeys.length)
                if(this.departmentSearch){
                    this.GetEnterpriseDepartment({
                        enterpriseId:localStorage.getItem('enterPriseId'),
                        name:this.departmentSearch
                    },false,showall)
                }else{
                    this.GetEnterpriseDepartment({
                        enterpriseId:localStorage.getItem('enterPriseId'),
                    })
                }
                
            },
            GetEnterpriseDepartment(params,loadalluser,showall){//获取企业部门
            //params查询参数，loadalluser(是否需要加载全公司成员),showall(是否展开全部树节点):
                let that=this;
                that.treeloading=true;
                GetEnterpriseDepartmentApi(params)
                .then(res=>{
                    if(res.status===200 && res.data.error_code===0){
                        const {data}=res.data;
                        console.log(data)

                        let treeArr=this.toTreeData(data)
                        this.treedata=treeArr;
                        that.treeloading=false;
                        if(this.treedata.length){
                            this.expandSecondLevel()//展开二级部门
                            
                        }
                        if(loadalluser===true){
                            this.loadallCompanyUser()//加载全公司成员
                        }
                        if(showall=='showall'){//展开所有节点
                            for (var i = 0; i < this.$refs.departmenttree.store._getAllNodes().length; i++) {
                                this.$refs.departmenttree.store._getAllNodes()[i].expanded = true;
                                
                                //记录节点展开状态
                                let ids=this.$refs.departmenttree.store._getAllNodes()[i].data.id;
                                this.defaultexpandedkeys.push(ids)
                            }
                        }

                        this.$nextTick(()=>{
                            this.$refs.departmenttree.setCurrentKey(this.currentdepid)
                        })
                        

                    }else{
                        this.$message.error(res.data.error_msg)
                        that.treeloading=false;
                    }
                })
                .catch(err=>{
                    that.treeloading=false;
                    if(err.data && err.data.errorMessages){
                        that.$message.error(err.data.errorMessages[0]);
                    }else if(err.data){
                        that.$message.error(err.data);
                    }
                })            
            },
            loadallCompanyUser(){
                if(this.treedata.length){
                    this.currentdepid=this.treedata[0].id
                    this.$emit('refreshUser',this.treedata[0].id)
                }
                
            },
            toTreeData(data, attr) {//将父子关系的数组转化为树结构
                let tree = [];
                let resultLevelArr=[]
                for(let i=0;i<100;i++){//根据level找出顶级元素
                    resultLevelArr=data.filter(item=>{
                        return item.level===i
                    })
                    if(resultLevelArr.length){
                        break
                    }
                }
                resultLevelArr.map(item =>{
                        let obj = {
                            id:item.enterpriseDepartmentId,
                            label:item.departmentName,
                            parentId:item.parentId,
                            level:item.level,
                            children:[]
                        }
                        tree.push(obj)//把最外层父级push进去
                })
                
                let res=this.childerData(tree,data)
                return res
            },
            childerData(tree,data){
                for(let i=0;i<tree.length;i++){//循环树形父级元素
                    for(let j = 0;j<data.length;j++){//循环数据
                    //判断数据的pid是不是等于父级的id，如果是则代表是当前父级的子级
                        if(tree[i].id == data[j].parentId){
                            let obj = {
                                id:data[j].enterpriseDepartmentId,
                                label:data[j].departmentName,
                                children:[],
                                level:data[j].level,
                                parentId:data[j].parentId,
                            }
                            tree[i].children.push(obj);//加入到父级的子级数组中
                        }
                    }
                    this.childerData(tree[i].children,data)//递归调用自己，传入第二层元素 
                }
                return tree
            },
            deleteBtnClick(node,data){//删除树节点
                let that=this;
                console.log(node,data)
                if(node.level==1){
                    this.$message.error('顶级部门不允许删除！')
                    return 
                }
                if(node.childNodes.length){
                    this.$message.error('部门下有子部门，不允许删除')
                    return 
                }

                this.$confirm(`您确定删除部门${data.label}吗?`, '提示信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    customClass: 'message-logout'
                }).then(() => {
                        GetEnterpriseDepartmentStatusApi({
                            enterpriseId:localStorage.getItem('enterPriseId'),
                            enterpriseDepartmentId:data.id,
                        })
                        .then(res=>{
                            if(res.status===200 && res.data.error_code===0){
                                const depstatus=res.data.data
                                if(depstatus===0){//没有子管理员和部门授权
                                    this.deleteFun(node,data)
                                }else{
                                    this.deldepConfirmTip(node,data,depstatus)//做相应的提示
                                }
                            }else{
                                this.$message.error(res.data.error_msg)
                            }
                        })
                        .catch(err=>{
                             this.treeloading=false;
                            if(err.data && err.data.errorMessages){
                                that.$message.error(err.data.errorMessages[0]);
                            }else if(err.data){
                                that.$message.error(err.data);
                            }
                        })       
                }).catch(() => {  

                });
            },
            deldepConfirmTip(node,data,depstatus){
                let tip=""
                if(depstatus===1){
                    tip='该部门下有上级部门分拨的授权，删除时，将回收该部门下全部授权，确定要删除吗'
                }else if(depstatus===2){
                    this.$message.error('该部门下有管理员不允许删除，请先删除该部门的管理员!')
                    return 
                }else if(depstatus===3){//两种情况都存在，部门下有授权 又有子管理员
                    this.$message.error('该部门下有管理员不允许删除，请先删除该部门的管理员!')
                    return 
                }
                this.$confirm(tip, '提示信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    customClass: 'message-logout'
                }).then(() => {
                    this.deleteFun(node,data)
                })
                .catch(() => {  

                });
            },
            deleteFun(node,data){//删除部门调用接口
                this.treeloading=true;
                        DeleteEnterpriseDepartmentApi({
                            enterpriseId:localStorage.getItem('enterPriseId'),
                            enterpriseDepartmentId:data.id,
                        })
                        .then(res=>{
                            if(res.status===200 && res.data.error_code===0){
                                console.log(res.data)
                                this.$message.success('部门删除成功！')
                                if(data.id==this.currentdepid){
                                    this.currentdepid='';
                                    
                                    this.GetEnterpriseDepartment({
                                        enterpriseId:localStorage.getItem('enterPriseId'),
                                    },true)//需要加载全公司成员，并把当前部门id置为全公司
                                }else{
                                    this.GetEnterpriseDepartment({
                                        enterpriseId:localStorage.getItem('enterPriseId'),
                                    })
                                }
                                
                            }else{
                                this.treeloading=false;
                                this.$message.error(res.data.error_msg)
                            }
                        })
                        .catch(err=>{
                            this.treeloading=false;
                            if(err.data && err.data.errorMessages){
                                that.$message.error(err.data.errorMessages[0]);
                            }else if(err.data){
                                that.$message.error(err.data);
                            }
                        })
            },
            editBtnClick(node,data){//编辑树节点按钮点击
                console.log(data)
                this.editLabel='',
                this.editLabel=node.label

                this.$set(data,'isOperate',true)
                this.$set(data,'type','edit')
                this.$nextTick(() => {
                    if (this.$refs["slotTreeInput" + data.id]) {
                        this.isCanLabelHover=false;
                        this.$refs["slotTreeInput" + data.id].$refs.input.focus();
                    }
                });
            },
            addBtnClick(node,data){
                
                if (node.level >= 7) {
                    this.$message.warning(
                    "当前部门层级已达到" + 6 + "级，无法新增！"
                    );
                    return false;
                }
                
                const newChild = {
                    id: new Date().getTime(),
                    label:'',
                    children: [],
                    isOperate: true,
                    type:'add'
                };
                if (!data.children) {
                    this.$set(data, "children", []);
                }
                this.$refs.departmenttree.store.nodesMap[data.id].expanded = true;
                data.children.push(newChild);
                this.$nextTick(() => {
                    if (this.$refs["slotaddInput" + newChild.id]) {
                        setTimeout(()=>{
                            this.addLabel=(node.level)+'级部门'
                            this.isCanLabelHover=false;
                            this.$refs["slotaddInput" + newChild.id].$refs.input.focus();
                        },0) 
                    }
                });
            },
            editblur(node,data){//编辑文本框失去焦点事件
                let that=this
                console.log(node,data)
                this.isCanLabelHover=true;
                if (data.isOperate) {
                    this.$set(data, "isOperate", false);
                    
                    if(this.editLabel && this.editLabel!=data.label){
                        
                        console.log('调用编辑接口')
                        this.treeloading=true;
                        EditEnterpriseDepartmentApi({
                            enterpriseDepartmentId:data.id,
                            level:data.level,
                            departmentName:this.editLabel,
                            enterpriseId:localStorage.getItem('enterPriseId'),
                            parentId:node.parent.data.id
                        })
                        .then(res=>{
                            if(res.status===200 && res.data.error_code===0){
                                console.log(res,'---')
                                this.$message.success('部门编辑成功')
                                this.GetEnterpriseDepartment({
                                    enterpriseId:localStorage.getItem('enterPriseId'),
                                })
                                this.$emit('refreshUser',data.id)
                            }else{
                                this.treeloading=false;
                                this.$message.error(res.data.error_msg)
                            }
                        })
                        .catch(err=>{
                            if(err.data && err.data.errorMessages){
                                that.$message.error(err.data.errorMessages[0]);
                            }else if(err.data){
                                that.$message.error(err.data);
                            }
                            this.treeloading=false;
                        })

                    }
                }
            },
            addblur(node,data){//添加时候文本框失去焦点事件
                let that=this;
                this.isCanLabelHover=true;
                if (data.isOperate) {
                    this.$set(data, "isOperate", false);
                    if(this.addLabel){
                        //this.$set(data,'label',this.addLabel)
                        console.log('调用添加接口')
                        console.log(node,data)
                        this.treeloading=true;
                        CreateEnterpriseDepartmentApi({
                            enterpriseId:localStorage.getItem('enterPriseId'),
                            parentId:node.parent.data.id,
                            departmentName:this.addLabel,
                            level:parseInt(node.level)-1
                        })
                        .then(res=>{
                            if(res.status===200 && res.data.error_code===0){
                            const {data}=res.data;
                                console.log(data)
                                this.defaultexpandedkeys.push(data.enterpriseDepartmentId)  
                                this.$message.success('部门新增成功')
                                this.GetEnterpriseDepartment({
                                    enterpriseId:localStorage.getItem('enterPriseId'),
                                })
                            }else{
                                this.treeloading=false;
                                this.$message.error(res.data.error_msg)
                            }
                        })
                        .catch(err=>{
                            if(err.data && err.data.errorMessages){
                                that.$message.error(err.data.errorMessages[0]);
                            }else if(err.data){
                                that.$message.error(err.data);
                            }
                            this.treeloading=false;
                            this.$refs.departmenttree.remove(node)
                        })
                    }else{
                        this.$refs.departmenttree.remove(node)
                    }
                }
            },
            dragControllerDiv(){//拖拉
                let resize=document.getElementById('treeresize')
                let left=document.getElementById('treeleft')
                resize.onmousedown = function (e) {
                    let startX = e.clientX
                    left.width = left.offsetWidth
                    document.onmousemove = function (e) {
                        let endX = e.clientX
                        let moveLen = left.width + (endX - startX)
                        if(moveLen<280){
                            moveLen=280
                        }else if(moveLen>660){
                            moveLen=660
                        }
                        left.style.width = moveLen + 'px'
                    
                    }

                    document.onmouseup = function () {
                    document.onmousemove = null
                    document.onmouseup = null
                    resize.releaseCapture && resize.releaseCapture()
                    }
                    resize.setCapture && resize.setCapture()
                    return false
                }
            },
            nodemouseleave(data,$event){//节点鼠标移出事件
                //$event.target.firstElementChild.nextElementSibling.setAttribute('class','node-none')
                this.$set(data, 'dropdownShow', false)
                
            },
            nodemouseover(data,$event){//节点鼠标移入事件
                //$event.target.nextElementSibling.setAttribute('class','node-block');
                this.$set(data, 'dropdownShow', true)
      
            },
            arrowfold(){//部门数收起
                this.arrowShow=false
            },
            arrowspan(){//部门数展开
                this.arrowShow=true
            }
        }
    }
</script>

<style lang="scss" scoped>
    #departmentTree{
        //padding: 30px 2px 20px 20px;
       
        display: flex;
        .search-header-wraper{
            width: 100%;
            display: flex;
            .fold-div{
                margin-top: 1px;
                margin-left: 10px;
                margin-right: 10px;
                height: 34px;
                width: 34px;
                background: #F5F5F5;
                border-radius: 2px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
        }
        .tree-left{
           padding-bottom:30px;
           padding-left: 20px;
           margin-top: 30px;
           width: 280px;
            .mytree{
                width: 100%;
                text-align: left;
                padding-top: 25px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #333;
                /deep/ .el-tree{
                    color: #333;
                }
                .custom-tree-node{
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    
                    .custom-label{
                        padding: 2px 2px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    .node-none{
                        width: 80px;
                        visibility: hidden;
                        font-size: 14px;
                        color: #999999;
                    }
                    .node-block{
                        width: 80px;
                        font-size: 14px;
                        color: #999999;
                    }
                    .opthover{
                        color: #333;
                    }
                    .opthover:hover{
                        color: #0069e0 !important;
                    }
                }
                /deep/ .el-tree-node__content{
                    padding: 2px 2px;
                    height:32px
                }
            }
           
        }
        .dragbox{
            width: 10px;
            margin: 30px 0px;
            cursor: e-resize;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            border-left: 1px solid #F5F5F5;
            .topsan{
                width: 0;
                height: 0;
                border-top: 10px solid transparent;
                border-left: 10px solid rgb(193,193,193);
                border-bottom: 0 solid yellowgreen;
                border-right:  0 solid green;
            }
            .bottomsan{
                width: 0;
                height: 0;
                border-bottom: 10px solid transparent;
                border-left: 10px solid rgb(193,193,193);
                border-top: 0 solid yellowgreen;
                border-right:  0 solid green;
            }
            .bgc-drag{
                background: rgb(193,193,193);
                width: 10px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                i{
                    color: #fff;
                }
            }
        }
        
    }
    /deep/ .mytree {
    .el-tree--highlight-current
        .el-tree-node.is-current
        > .el-tree-node__content {
        // 设置颜色
        background-color: #F4F5F6;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #0069e0;
        background: #E8F4FF;
    }
    .inputadd{
        .el-input__inner{
            padding: 0px 2px;
        }
    }
  }
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/companyManage/departmentTree.vue